// polyfill
import 'intersection-observer';
/*
// import Expousure from './exposure';
// const expousure = new Expousure();

      // if (binding.arg === SHOW_NAME) {
      //   if (!expousure._context) {
      //     expousure._context = vnode.context;
      //   }
      //   expousure.attach(el);
      // }

  // expousure.notify(function (el) {
  //   const key = _createAttributeName(SHOW_NAME);
  //   const value = el.getAttribute(key);
  //   if (!value) {
  //     return;
  //   }
  //   stat.track(JSON.parse(value), this.context ? this.context.$root : null);
  // });
*/
// 可以把节流的时间调大一点，默认是100ms
IntersectionObserver.prototype['THROTTLE_TIMEOUT'] = 300;

export default class Exposure {
  constructor () {
    // 全局只会实例化一次Exposure类，init方法也只会执行一次
    this.init();
    this.actions = [];
  }

  init () {
    const self = this;
    this._observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(entry => {
        // 元素进入视窗时触发
        if (entry.isIntersecting) {
          // 取消对dom元素的观察
          if (entry.target.__exposure_once) {
            self.detach(entry.target);
            entry.target.__exposure_onced = true;
          }
          // 执行曝光方法
          let len = self.actions.length;
          for (let i = 0; i < len; i++) {
            self.actions[i](entry.target);
          }
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // 不一定非得全部露出来  这个阈值可以小一点点
    });
    window.addEventListener('beforeunload', function () {
      self.disconnect();
    });
    window.addEventListener('unload', function (event) {
      self.disconnect();
    });
  }
  // 添加观察元素
  attach (element, once) {
    element.__exposure_once = !!once;
    this._observer && this._observer.observe(element);
  }
  // 删除观察元素
  detach (element) {
    this._observer && this._observer.unobserve(element);
  }
  // 通知变更
  notify (callback) {
    if (callback && typeof callback === 'function') {
      this.actions.push(callback);
    }
  }
  disconnect () {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }
}
